import PropTypes from 'prop-types'
import classNames from 'classnames'

// components
import Popup from '@aytm/lib/rfd-ui/components/basic/popup'

// styles
import style from '@aytm/app/stats/page/question-views/vk/components/views/chart/components/chart-buttons/styles/ChartButtons.module.scss'

// The help copy marks its paragraph break as `<br/>`; the popup draws text, so the break is made an element
// rather than handing the string to the DOM as markup.
const helpLines = tooltip =>
  String(tooltip || '')
    .split(/<br\s*\/?>/i)
    .flatMap((line, i) => (0 === i ? [line] : [<br key={i} />, line]))

const ChartButtonsPanel = ({ children, title, tooltip, text, footer }) => (
  <>
    <div className={style.panel}>
      <div className={style.panelTitle} dangerouslySetInnerHTML={{ __html: title }} />
      <div className={classNames('p-inputgroup', style.panelInputGroup)}>
        {children}
        <span className={classNames('p-inputgroup-addon', style.inputAddon)}>
          <Popup
            width="400px"
            trigger="click"
            direction="righttop"
            popupOffset={9}
            hideOtherPopupsOnShow
            content={() => helpLines(tooltip)}
          >
            <i className="icon-aytmfd-help-v2" />
          </Popup>
        </span>
      </div>
      <div className={style.panelText} dangerouslySetInnerHTML={{ __html: text }} />
    </div>
    {footer && <div className={style.panelFooter}>{footer}</div>}
  </>
)

ChartButtonsPanel.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
  tooltip: PropTypes.string,
  text: PropTypes.string,
  footer: PropTypes.any
}

export default ChartButtonsPanel
